import { render } from "./billManage _back.vue?vue&type=template&id=dd4349b4"
import script from "./billManage _back.vue?vue&type=script&lang=js"
export * from "./billManage _back.vue?vue&type=script&lang=js"

import "./billManage _back.vue?vue&type=style&index=0&id=dd4349b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__